import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { setAuthCookie, setAuthToken } from '@/utils/authToken.js'

export const useAuthStore = defineStore('auth', () => {
  // null или объект { id, email, role }
  const user = ref(null)
  const role = ref(null)
  const token = ref(null)
  const loginRequestId = ref(0)
  const pendingWatcher = ref(null)

  const isAuthed = computed(() => !!token.value)

  function setAuth(payload) {
    user.value = payload?.user ?? null
    role.value = payload?.role ?? null
    token.value = payload?.token ?? null
    setAuthToken(token.value)
    if (typeof window !== 'undefined') {
      if (token.value) localStorage.setItem('token', token.value)
      else localStorage.removeItem('token')
      setAuthCookie(token.value)
    }
  }

  function setUser(nextUser) {
    user.value = nextUser
  }

  function patchUser(partial) {
    if (!user.value) user.value = {}
    user.value = { ...user.value, ...partial }
  }

  function requestLogin(watcher = null) {
    pendingWatcher.value = watcher
    loginRequestId.value += 1
  }

  function consumePendingWatcher() {
    const watcher = pendingWatcher.value
    pendingWatcher.value = null
    return watcher
  }

  function clearPendingWatcher() {
    pendingWatcher.value = null
  }

  function logout() {
    setAuth(null)
    pendingWatcher.value = null
  }

  return {
    user,
    role,
    token,
    isAuthed,
    loginRequestId,
    setAuth,
    setUser,
    patchUser,
    requestLogin,
    consumePendingWatcher,
    clearPendingWatcher,
    logout
  }
})
